import { useCookies } from "react-cookie"
import { COOKIE_EXPIRATION } from "shared/constant/cookie.constant"

const useRoleCookie = () => {

    const cookieName = "TRC1"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (role) => {
        setCookie(cookieName, role, {
            "path": "/",
            // "sameSite": "none",
            // "secure": true,
            "expires": new Date(Date.now() + COOKIE_EXPIRATION.ONE_MONTH)
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    return [cookie[cookieName], createCookie, deleteCookie]
}

export default useRoleCookie